import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InternationalAdmissionsRoutingModule } from './international-admissions-routing.module';
import { InternationalAdmissionsComponent } from './international-admissions.component';
import { WhyChooseAarniComponent } from './why-choose-aarni/why-choose-aarni.component';
import { ScholarshipComponent } from './scholarship/scholarship.component';
import {TruncatewordsPipe} from "../../../shared/pipes/truncatewords.pipe";
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    InternationalAdmissionsComponent,
    WhyChooseAarniComponent,
    ScholarshipComponent,
      TruncatewordsPipe
  ],
    imports: [
        CommonModule,
        InternationalAdmissionsRoutingModule,
        ReactiveFormsModule,

    ]
})
export class InternationalAdmissionsModule { }
